import { defineMessages } from 'react-intl-next';

export default defineMessages({
    signupWarningMessage: {
        defaultMessage: 'Before you can send this request, {signUpLink} to continue',
        description: 'Message to redirect to sign up page before creating request.',
        id: 'cv.request.create.form.anonymousEmail.signupWarningMessage',
    },
    signupLink: {
        defaultMessage: 'sign up',
        description: 'label for sign up link',
        id: 'cv.request.create.form.anonymousEmail.signupLink',
    },
});
